import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'rol-aging',
    templateUrl: './aging.component.html',
    styleUrls: ['./aging.component.scss'],
    standalone: false,
})
export class AgingComponent implements OnInit {
    constructor() {}

    ngOnInit(): void {}
}
